const processingApplicationDrafts = [
    {
        "no": "1001",
        "name": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "certificateRegion": "domestic",
        "appNo": "202100012",
        "appType": "initial",
        "formType": ["processing"],
        "createdOn": "2021-05-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "翁家仁",
            "gender": "male",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "certificationPlaces": [
            {
                "name": "桃園廠",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002882"
            }
        ],
        "whetherHasOffsiteStorage": "yes",
        "offSiteStorages": [
            {
                "purpose": "疫情趨緩，但宅經濟趨勢不變，遠傳電信觀察，代收交易金額年增成長20%至25%，且有持續成長趨勢，遊戲及影音服務使用率大增，準備中元普渡也轉向線上網購。",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                }
            },
        ],
        "entrustedCompanies": [
            {
                "name": "苗栗縣南庄鄉農會",
                "address": "桃園市中山區中山路19-11號",
                "phone": "02-7723-8001",
                "certificationBody": "國立中興大學 "
            }
        ],
        "certificationProducts": [
            {
                "name": "有機黑豆漿",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 200,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    }
                ],
                "compositions": [
                    {
                        "name": "水"
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 93.57,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "統盛國際股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "PRO-CRRT",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "友綠生活有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Ecocert Canada",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "四季有機國際有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "行健友善有機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機砂糖",
                        "proportion": 6.42,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機砂糖",
                                "originPlace": "巴拉圭",
                                "type": "organic",
                                "importer": "維多創新生機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Control Union Certifications B.V.",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "立圃產業有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    },
                    {
                        "name": "碳酸氫鈉",
                        "proportion": 0.01,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "碳酸氫鈉",
                                "originPlace": "美國",
                                "type": "organic",
                                "manufacturer": "TATA CHEMICALS",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水"
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 93.57,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "統盛國際股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "PRO-CRRT",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "友綠生活有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Ecocert Canada",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "四季有機國際有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "行健友善有機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機砂糖",
                                "proportion": 6.42,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機砂糖",
                                        "originPlace": "巴拉圭",
                                        "type": "organic",
                                        "importer": "維多創新生機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Control Union Certifications B.V.",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "立圃產業有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            },
                            {
                                "name": "碳酸氫鈉",
                                "proportion": 0.01,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "碳酸氫鈉",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "manufacturer": "TATA CHEMICALS",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            }
                        ],
                    },
                ]
            },
            {
                "name": "有機豆瓣醬",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    }
                ],
                "compositions": [
                    {
                        "name": "水",
                        "compositionLevel": "water"
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 30,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT SA",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "簡單生活開發公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ACO CERTIFICATION LTD",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機辣椒",
                        "proportion": 25,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "邱松榮",
                                "acquisitionStandard": "TW",
                                "certificationBody": "台灣省有機農業生產協會",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吉品養生",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 20,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吳俊佑(豐耕有機農場)",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "綠昇貿易行銷有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT CANADA",
                            }
                        ]
                    },
                    {
                        "name": "有機小麥",
                        "proportion": 10,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機小麥",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機小麥",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "海鹽",
                        "compositionLevel": "salt",
                        "rawMaterials": [
                            {
                                "name": "海鹽",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "尚達鹽業",
                                "acquisitionStandard": "TW",
                            }
                        ]
                    },
                    {
                        "name": "有機香菇",
                        "proportion": 8,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "錦山有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    },
                    {
                        "name": "有機醬油",
                        "proportion": 5,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機醬油",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778",
                                "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                            },
                        ]
                    },
                    {
                        "name": "乾海帶",
                        "proportion": 1.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "乾海帶",
                                "originPlace": "韓國",
                                "type": "organic",
                                "importer": "新藻實業有限公司",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]

                    },
                    {
                        "name": "種麴",
                        "proportion": 0.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "種麴",
                                "originPlace": "日本",
                                "type": "organic",
                                "importer": "萬通(世群貿易)",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水",
                                "compositionLevel": "water"
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 30,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT SA",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "簡單生活開發公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ACO CERTIFICATION LTD",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機辣椒",
                                "proportion": 25,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "邱松榮",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "台灣省有機農業生產協會",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吉品養生",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 20,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吳俊佑(豐耕有機農場)",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "綠昇貿易行銷有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT CANADA",
                                    }
                                ]
                            },
                            {
                                "name": "有機小麥",
                                "proportion": 10,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "海鹽",
                                "compositionLevel": "salt",
                                "rawMaterials": [
                                    {
                                        "name": "海鹽",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "尚達鹽業",
                                        "acquisitionStandard": "TW",
                                    }
                                ]
                            },
                            {
                                "name": "有機香菇",
                                "proportion": 8,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "錦山有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            },
                            {
                                "name": "有機醬油",
                                "proportion": 5,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機醬油",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778",
                                        "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                                    },
                                ]
                            },
                            {
                                "name": "乾海帶",
                                "proportion": 1.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "乾海帶",
                                        "originPlace": "韓國",
                                        "type": "organic",
                                        "importer": "新藻實業有限公司",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]

                            },
                            {
                                "name": "種麴",
                                "proportion": 0.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "種麴",
                                        "originPlace": "日本",
                                        "type": "organic",
                                        "importer": "萬通(世群貿易)",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            }
                        ],
                    },
                ]
            }
        ],
        "rawMaterials": [
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "上安",
                "importer": "上安",
                "acquisitionStandard": "TW",
                "certificationBody": "中興",
                "additiveLicenseNumber": "123456778"
            },
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "森岳",
                "importer": "森岳",
                "acquisitionStandard": "TW",
                "certificationBody": "中華",
                "additiveLicenseNumber": "123456778"
            }
        ]
    },
    {
        "no": "1002",
        "name": "中等生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "US",
                "category": ["crop"]
            }
        ],
        "certificateRegion": "domestic",
        "appNo": "202100022",
        "appType": "initial",
        "formType": ["crop"],
        "createdOn": "2021-06-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "王佳佳",
            "gender": "female",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "transitionTotalArea": 0,
        "organicTotalArea": 0.0164,
        "usCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "249地號",
                "address": "高雄市美濃區廣林段249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "258地號",
                "address": "高雄市美濃區廣林段258地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "sourceTreatments": [
            {
                "cropName": "地瓜葉",
                "source": "seeds",
                "organicType": "organic",
                "seedTreatment": ["withoutMedication"]
            },
            {
                "cropName": "小白菜",
                "source": "seeding",
                "organicType": "nonOrganic",
                "seedTreatment": ["withMedication"],
                "medicationType": "抗細菌藥/金黃色葡萄球菌/依原體"
            }
        ]

    },
    {
        "no": "1003",
        "name": "中等生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["crop"]
            }
        ],
        "certificateRegion": "overseas",
        "appNo": "202100023",
        "appType": "initial",
        "formType": ["crop"],
        "createdOn": "2021-06-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "王佳佳",
            "gender": "female",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": "No. 19-11, San Chong Rd.,",
        "mailingAddress": "No. 19-11, San Chong Rd.,",
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "transitionTotalArea": 0,
        "organicTotalArea": 0.0164,
        "twCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                "longitude": "41°24'12.2N ",
                "latitude": "2°10'26.5E",
                "address": "高雄市美濃區廣林段249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                "longitude": "42°24'12.2N ",
                "latitude": "3°10'26.5E",
                "address": "高雄市美濃區廣林段249地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "sourceTreatments": [
            {
                "cropName": "地瓜葉",
                "source": "seeds",
                "organicType": "organic",
                "seedTreatment": ["withoutMedication"]
            },
            {
                "cropName": "小白菜",
                "source": "seeding",
                "organicType": "nonOrganic",
                "seedTreatment": ["withMedication"],
                "medicationType": "抗細菌藥/金黃色葡萄球菌/依原體"
            }
        ]

    },
    {
        "no": "2001",
        "name": "複雜生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "US",
                "category": ["crop", "handling"]
            },
            {
                "standard": "EU",
                "category": ["crop", "processing"]
            }
        ],
        "certificateRegion": "domestic",
        "appNo": "202100098",
        "appType": "initial",
        "formType":["crop","processing"],
        "createdOn": "2021-06-30T08:20:10.000Z",
        "personInCharge": {
            "name": "郝佳佳",
            "gender": "female",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "group",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "certificationPlaces": [
            {
                "name": "桃園廠",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002882"
            }
        ],
        "whetherHasOffsiteStorage": "yes",
        "offSiteStorages": [
            {
                "purpose": "疫情趨緩，但宅經濟趨勢不變，遠傳電信觀察，代收交易金額年增成長20%至25%，且有持續成長趨勢，遊戲及影音服務使用率大增，準備中元普渡也轉向線上網購。",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                }
            },
        ],
        "entrustedCompanies": [
            {
                "name": "苗栗縣南庄鄉農會",
                "address": "桃園市中山區中山路19-11號",
                "phone": "02-7723-8001",
                "certificationBody": "國立中興大學 "
            }
        ],
        "certificationProducts": [
            {
                "name": "有機黑豆漿",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "US",
                        "certificationType": ["handling"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 200,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    }
                ],
                "compositions": [
                    {
                        "name": "有機黑豆",
                        "proportion": 70,
                        "compositionLevel": "organic",
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 20.12,
                        "compositionLevel": "organic",
                    },
                    {
                        "name": "水",
                        "compositionLevel": "water",
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"US",
                        "compositions":[
                            {
                                "name": "有機黑豆",
                                "proportion": 70,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "中國",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "鴻旗農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "東石農會",
                                        "importer": "東石農會",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "滿洲農會",
                                        "importer": "滿洲農會",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "和諧",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲農會",
                                        "importer": "十甲農會",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 20.12,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖",
                                        "originPlace": "中國",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    }]
                            },
                            {
                                "name": "水",
                                "compositionLevel": "water",
                            }
                        ]
                    },
                ]
            },
            {
                "name": "有機豆瓣醬",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "EU",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    }
                ],
                "compositions": [
                    {
                        "name": "有機黃豆",
                        "proportion": 70,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "manufacturer": "SB&B",
                                "importer": "喜樂之泉",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "manufacturer": "SG CERESCO",
                                "importer": "喜樂之泉",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 20.12,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機蔗糖",
                                "originPlace": "中國",
                                "type": "organic",
                                "manufacturer": "NORTH TRADING ",
                                "importer": "喜樂之泉",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證",
                                "additiveLicenseNumber": "123456778"
                            }]
                    },
                    {
                        "name": "有機香菇",
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "上安",
                                "importer": "上安",
                                "acquisitionStandard": "TW",
                                "certificationBody": "中興",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "森岳",
                                "importer": "森岳",
                                "acquisitionStandard": "TW",
                                "certificationBody": "中華",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    }
                ],
                "rawMaterials":[
                    {
                        "certificateStandard":"EU",
                        "compositions": [
                            {
                                "name": "有機黃豆",
                                "proportion": 70,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "manufacturer": "SB&B",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "manufacturer": "SG CERESCO",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 20.12,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖",
                                        "originPlace": "中國",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    }]
                            },
                            {
                                "name": "有機香菇",
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "上安",
                                        "importer": "上安",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "中興",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "森岳",
                                        "importer": "森岳",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "中華",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            }
                        ]
                    },
                ]
            }
        ],
        "rawMaterials": [
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "上安",
                "importer": "上安",
                "acquisitionStandard": "TW",
                "certificationBody": "中興",
                "additiveLicenseNumber": "123456778"
            },
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "森岳",
                "importer": "森岳",
                "acquisitionStandard": "TW",
                "certificationBody": "中華",
                "additiveLicenseNumber": "123456778"
            }
        ],
        "transitionTotalArea": 0,
        "organicTotalArea": 0.0164,
        "usCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "249地號",
                "address": "高雄市美濃區廣林段249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "258地號",
                "address": "高雄市美濃區廣林段258地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "euCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                "address": "高雄市美濃區廣林段231地號",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "258地號",
                "address": "高雄市美濃區廣林段221地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "sourceTreatments": [
            {
                "cropName": "地瓜葉",
                "source": "seeds",
                "organicType": "organic",
                "seedTreatment": ["withoutMedication"]
            },
            {
                "cropName": "小白菜",
                "source": "seeding",
                "organicType": "nonOrganic",
                "seedTreatment": ["withMedication"],
                "medicationType": "抗細菌藥/金黃色葡萄球菌/依原體"
            }
        ]
    },
    {
        "no": "1005",
        "name": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "certificateRegion": "domestic",
        "appNo": "202100024",
        "appType": "followUp",
        "formType": ["processing"],
        "createdOn": "2021-05-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "翁家仁",
            "gender": "male",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "certificationPlaces": [
            {
                "name": "桃園廠",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002882"
            }
        ],
        "whetherHasOffsiteStorage": "yes",
        "offSiteStorages": [
            {
                "purpose": "疫情趨緩，但宅經濟趨勢不變，遠傳電信觀察，代收交易金額年增成長20%至25%，且有持續成長趨勢，遊戲及影音服務使用率大增，準備中元普渡也轉向線上網購。",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                }
            },
        ],
        "entrustedCompanies": [
            {
                "name": "苗栗縣南庄鄉農會",
                "address": "桃園市中山區中山路19-11號",
                "phone": "02-7723-8001",
                "certificationBody": "國立中興大學 "
            }
        ],
        "certificationProducts": [
            {
                "name": "有機黑豆漿",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 200,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔1.jpg",
                                "lastModified": 0
                            },
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔2.jpg",
                                "lastModified": 0
                            }
                        ]
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔3.jpg",
                                "lastModified": 0
                            },
                        ]
                    }
                ],
                "compositions": [
                    {
                        "name": "水"
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 93.57,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "統盛國際股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "PRO-CRRT",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "友綠生活有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Ecocert Canada",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "四季有機國際有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "行健友善有機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機砂糖",
                        "proportion": 6.42,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機砂糖",
                                "originPlace": "巴拉圭",
                                "type": "organic",
                                "importer": "維多創新生機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Control Union Certifications B.V.",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "立圃產業有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    },
                    {
                        "name": "碳酸氫鈉",
                        "proportion": 0.01,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "碳酸氫鈉",
                                "originPlace": "美國",
                                "type": "organic",
                                "manufacturer": "TATA CHEMICALS",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水"
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 93.57,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "統盛國際股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "PRO-CRRT",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "友綠生活有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Ecocert Canada",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "四季有機國際有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "行健友善有機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機砂糖",
                                "proportion": 6.42,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機砂糖",
                                        "originPlace": "巴拉圭",
                                        "type": "organic",
                                        "importer": "維多創新生機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Control Union Certifications B.V.",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "立圃產業有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            },
                            {
                                "name": "碳酸氫鈉",
                                "proportion": 0.01,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "碳酸氫鈉",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "manufacturer": "TATA CHEMICALS",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            }
                        ],
                    },
                ]
            },
            {
                "name": "有機豆瓣醬",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔1.jpg",
                                "lastModified": 0
                            },
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔2.jpg",
                                "lastModified": 0
                            }
                        ]
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔3.jpg",
                                "lastModified": 0
                            },
                        ]
                    }
                ],
                "compositions": [
                    {
                        "name": "水",
                        "compositionLevel": "water"
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 30,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT SA",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "簡單生活開發公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ACO CERTIFICATION LTD",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機辣椒",
                        "proportion": 25,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "邱松榮",
                                "acquisitionStandard": "TW",
                                "certificationBody": "台灣省有機農業生產協會",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吉品養生",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 20,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吳俊佑(豐耕有機農場)",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "綠昇貿易行銷有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT CANADA",
                            }
                        ]
                    },
                    {
                        "name": "有機小麥",
                        "proportion": 10,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機小麥",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機小麥",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "海鹽",
                        "compositionLevel": "salt",
                        "rawMaterials": [
                            {
                                "name": "海鹽",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "尚達鹽業",
                                "acquisitionStandard": "TW",
                            }
                        ]
                    },
                    {
                        "name": "有機香菇",
                        "proportion": 8,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "錦山有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    },
                    {
                        "name": "有機醬油",
                        "proportion": 5,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機醬油",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778",
                                "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                            },
                        ]
                    },
                    {
                        "name": "乾海帶",
                        "proportion": 1.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "乾海帶",
                                "originPlace": "韓國",
                                "type": "organic",
                                "importer": "新藻實業有限公司",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]

                    },
                    {
                        "name": "種麴",
                        "proportion": 0.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "種麴",
                                "originPlace": "日本",
                                "type": "organic",
                                "importer": "萬通(世群貿易)",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水",
                                "compositionLevel": "water"
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 30,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT SA",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "簡單生活開發公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ACO CERTIFICATION LTD",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機辣椒",
                                "proportion": 25,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "邱松榮",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "台灣省有機農業生產協會",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吉品養生",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 20,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吳俊佑(豐耕有機農場)",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "綠昇貿易行銷有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT CANADA",
                                    }
                                ]
                            },
                            {
                                "name": "有機小麥",
                                "proportion": 10,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "海鹽",
                                "compositionLevel": "salt",
                                "rawMaterials": [
                                    {
                                        "name": "海鹽",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "尚達鹽業",
                                        "acquisitionStandard": "TW",
                                    }
                                ]
                            },
                            {
                                "name": "有機香菇",
                                "proportion": 8,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "錦山有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            },
                            {
                                "name": "有機醬油",
                                "proportion": 5,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機醬油",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778",
                                        "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                                    },
                                ]
                            },
                            {
                                "name": "乾海帶",
                                "proportion": 1.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "乾海帶",
                                        "originPlace": "韓國",
                                        "type": "organic",
                                        "importer": "新藻實業有限公司",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]

                            },
                            {
                                "name": "種麴",
                                "proportion": 0.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "種麴",
                                        "originPlace": "日本",
                                        "type": "organic",
                                        "importer": "萬通(世群貿易)",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            }
                        ],
                    },
                ]
            }
        ],
        "rawMaterials": [
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "上安",
                "importer": "上安",
                "acquisitionStandard": "TW",
                "certificationBody": "中興",
                "additiveLicenseNumber": "123456778"
            },
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "森岳",
                "importer": "森岳",
                "acquisitionStandard": "TW",
                "certificationBody": "中華",
                "additiveLicenseNumber": "123456778"
            }
        ]
    },
    {
        "no": "1005",
        "name": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "certificateRegion": "overseas",
        "appNo": "202100029",
        "appType": "renewal",
        "formType": ["processing"],
        "createdOn": "2021-05-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "翁家仁",
            "gender": "male",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "certificationPlaces": [
            {
                "name": "桃園廠",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002882"
            }
        ],
        "whetherHasOffsiteStorage": "yes",
        "offSiteStorages": [
            {
                "purpose": "疫情趨緩，但宅經濟趨勢不變，遠傳電信觀察，代收交易金額年增成長20%至25%，且有持續成長趨勢，遊戲及影音服務使用率大增，準備中元普渡也轉向線上網購。",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                }
            },
        ],
        "entrustedCompanies": [
            {
                "name": "苗栗縣南庄鄉農會",
                "address": "桃園市中山區中山路19-11號",
                "phone": "02-7723-8001",
                "certificationBody": "國立中興大學 "
            }
        ],
        "certificationProducts": [
            {
                "name": "有機黑豆漿",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 200,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔1.jpg",
                                "lastModified": 0
                            },
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔2.jpg",
                                "lastModified": 0
                            }
                        ]
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔3.jpg",
                                "lastModified": 0
                            },
                        ]
                    }
                ],
                "compositions": [
                    {
                        "name": "水"
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 93.57,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "統盛國際股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "PRO-CRRT",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "友綠生活有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Ecocert Canada",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "四季有機國際有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "行健友善有機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機砂糖",
                        "proportion": 6.42,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機砂糖",
                                "originPlace": "巴拉圭",
                                "type": "organic",
                                "importer": "維多創新生機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Control Union Certifications B.V.",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "立圃產業有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    },
                    {
                        "name": "碳酸氫鈉",
                        "proportion": 0.01,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "碳酸氫鈉",
                                "originPlace": "美國",
                                "type": "organic",
                                "manufacturer": "TATA CHEMICALS",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水"
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 93.57,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "統盛國際股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "PRO-CRRT",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "友綠生活有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Ecocert Canada",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "四季有機國際有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "行健友善有機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機砂糖",
                                "proportion": 6.42,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機砂糖",
                                        "originPlace": "巴拉圭",
                                        "type": "organic",
                                        "importer": "維多創新生機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Control Union Certifications B.V.",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "立圃產業有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            },
                            {
                                "name": "碳酸氫鈉",
                                "proportion": 0.01,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "碳酸氫鈉",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "manufacturer": "TATA CHEMICALS",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            }
                        ],
                    },
                ]
            },
            {
                "name": "有機豆瓣醬",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔1.jpg",
                                "lastModified": 0
                            },
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔2.jpg",
                                "lastModified": 0
                            }
                        ]
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔3.jpg",
                                "lastModified": 0
                            },
                        ]
                    }
                ],
                "compositions": [
                    {
                        "name": "水",
                        "compositionLevel": "water"
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 30,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT SA",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "簡單生活開發公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ACO CERTIFICATION LTD",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機辣椒",
                        "proportion": 25,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "邱松榮",
                                "acquisitionStandard": "TW",
                                "certificationBody": "台灣省有機農業生產協會",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吉品養生",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 20,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吳俊佑(豐耕有機農場)",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "綠昇貿易行銷有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT CANADA",
                            }
                        ]
                    },
                    {
                        "name": "有機小麥",
                        "proportion": 10,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機小麥",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機小麥",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "海鹽",
                        "compositionLevel": "salt",
                        "rawMaterials": [
                            {
                                "name": "海鹽",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "尚達鹽業",
                                "acquisitionStandard": "TW",
                            }
                        ]
                    },
                    {
                        "name": "有機香菇",
                        "proportion": 8,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "錦山有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    },
                    {
                        "name": "有機醬油",
                        "proportion": 5,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機醬油",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778",
                                "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                            },
                        ]
                    },
                    {
                        "name": "乾海帶",
                        "proportion": 1.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "乾海帶",
                                "originPlace": "韓國",
                                "type": "organic",
                                "importer": "新藻實業有限公司",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]

                    },
                    {
                        "name": "種麴",
                        "proportion": 0.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "種麴",
                                "originPlace": "日本",
                                "type": "organic",
                                "importer": "萬通(世群貿易)",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水",
                                "compositionLevel": "water"
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 30,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT SA",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "簡單生活開發公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ACO CERTIFICATION LTD",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機辣椒",
                                "proportion": 25,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "邱松榮",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "台灣省有機農業生產協會",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吉品養生",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 20,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吳俊佑(豐耕有機農場)",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "綠昇貿易行銷有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT CANADA",
                                    }
                                ]
                            },
                            {
                                "name": "有機小麥",
                                "proportion": 10,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "海鹽",
                                "compositionLevel": "salt",
                                "rawMaterials": [
                                    {
                                        "name": "海鹽",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "尚達鹽業",
                                        "acquisitionStandard": "TW",
                                    }
                                ]
                            },
                            {
                                "name": "有機香菇",
                                "proportion": 8,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "錦山有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            },
                            {
                                "name": "有機醬油",
                                "proportion": 5,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機醬油",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778",
                                        "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                                    },
                                ]
                            },
                            {
                                "name": "乾海帶",
                                "proportion": 1.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "乾海帶",
                                        "originPlace": "韓國",
                                        "type": "organic",
                                        "importer": "新藻實業有限公司",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]

                            },
                            {
                                "name": "種麴",
                                "proportion": 0.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "種麴",
                                        "originPlace": "日本",
                                        "type": "organic",
                                        "importer": "萬通(世群貿易)",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            }
                        ],
                    },
                ]
            }
        ],
        "rawMaterials": [
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "上安",
                "importer": "上安",
                "acquisitionStandard": "TW",
                "certificationBody": "中興",
                "additiveLicenseNumber": "123456778"
            },
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "森岳",
                "importer": "森岳",
                "acquisitionStandard": "TW",
                "certificationBody": "中華",
                "additiveLicenseNumber": "123456778"
            }
        ]
    },
    {
        "no": "1002",
        "name": "中等生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["crop"]
            }
        ],
        "certificateRegion": "overseas",
        "appNo": "202100025",
        "appType": "renewal",
        "formType": ["crop"],
        "createdOn": "2021-06-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "王佳佳",
            "gender": "female",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "transitionTotalArea": 0,
        "organicTotalArea": 0.0164,
        "usCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "249地號",
                "address": "高雄市美濃區廣林段249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "258地號",
                "address": "高雄市美濃區廣林段258地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "otherCertificationFields": [
            {
                "name": "開心農場",
                "address": "台北市南港區三重路19-11號"
            },
            {
                "name": "傷心農場",
                "address": "台北市南港區三重路19-00號"
            }
        ],
        "sourceTreatments": [
            {
                "cropName": "地瓜葉",
                "source": "seeds",
                "organicType": "organic",
                "seedTreatment": ["withoutMedication"]
            },
            {
                "cropName": "小白菜",
                "source": "seeding",
                "organicType": "nonOrganic",
                "seedTreatment": ["withMedication"],
                "medicationType": "抗細菌藥/金黃色葡萄球菌/依原體"
            }
        ]

    },
    {
        "no": "2001",
        "name": "複雜生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "US",
                "category": ["crop", "handling"]
            },
            {
                "standard": "EU",
                "category": ["crop", "processing"]
            }
        ],
        "certificateRegion": "domestic",
        "appNo": "202100026",
        "appType": "renewal",
        "formType":["crop","processing"],
        "createdOn": "2021-06-30T08:20:10.000Z",
        "personInCharge": {
            "name": "郝佳佳",
            "gender": "female",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "group",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "certificationPlaces": [
            {
                "name": "桃園廠",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002882"
            }
        ],
        "whetherHasOffsiteStorage": "yes",
        "offSiteStorages": [
            {
                "purpose": "疫情趨緩，但宅經濟趨勢不變，遠傳電信觀察，代收交易金額年增成長20%至25%，且有持續成長趨勢，遊戲及影音服務使用率大增，準備中元普渡也轉向線上網購。",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                }
            },
        ],
        "entrustedCompanies": [
            {
                "name": "苗栗縣南庄鄉農會",
                "address": "桃園市中山區中山路19-11號",
                "phone": "02-7723-8001",
                "certificationBody": "國立中興大學 "
            }
        ],
        "certificationProducts": [
            {
                "name": "有機黑豆漿",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "US",
                        "certificationType": ["handling"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 200,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    }
                ],
                "compositions": [
                    {
                        "name": "有機黑豆",
                        "proportion": 70,
                        "compositionLevel": "organic",
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 20.12,
                        "compositionLevel": "organic",
                    },
                    {
                        "name": "水",
                        "compositionLevel": "water",
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"US",
                        "compositions":[
                            {
                                "name": "有機黑豆",
                                "proportion": 70,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "中國",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "鴻旗農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "東石農會",
                                        "importer": "東石農會",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "滿洲農會",
                                        "importer": "滿洲農會",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "和諧",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黑豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲農會",
                                        "importer": "十甲農會",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 20.12,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖",
                                        "originPlace": "中國",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    }]
                            },
                            {
                                "name": "水",
                                "compositionLevel": "water",
                            }
                        ]
                    },
                ]
            },
            {
                "name": "有機豆瓣醬",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "EU",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐"
                    }
                ],
                "compositions": [
                    {
                        "name": "有機黃豆",
                        "proportion": 70,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "manufacturer": "SB&B",
                                "importer": "喜樂之泉",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "manufacturer": "SG CERESCO",
                                "importer": "喜樂之泉",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 20.12,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機蔗糖",
                                "originPlace": "中國",
                                "type": "organic",
                                "manufacturer": "NORTH TRADING ",
                                "importer": "喜樂之泉",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證",
                                "additiveLicenseNumber": "123456778"
                            }]
                    },
                    {
                        "name": "有機香菇",
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "上安",
                                "importer": "上安",
                                "acquisitionStandard": "TW",
                                "certificationBody": "中興",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "森岳",
                                "importer": "森岳",
                                "acquisitionStandard": "TW",
                                "certificationBody": "中華",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    }
                ],
                "rawMaterials":[
                    {
                        "certificateStandard":"EU",
                        "compositions": [
                            {
                                "name": "有機黃豆",
                                "proportion": 70,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "manufacturer": "SB&B",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "manufacturer": "SG CERESCO",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 20.12,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖",
                                        "originPlace": "中國",
                                        "type": "organic",
                                        "manufacturer": "NORTH TRADING ",
                                        "importer": "喜樂之泉",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證",
                                        "additiveLicenseNumber": "123456778"
                                    }]
                            },
                            {
                                "name": "有機香菇",
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "上安",
                                        "importer": "上安",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "中興",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "森岳",
                                        "importer": "森岳",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "中華",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            }
                        ]
                    },
                ]
            }
        ],
        "rawMaterials": [
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "上安",
                "importer": "上安",
                "acquisitionStandard": "TW",
                "certificationBody": "中興",
                "additiveLicenseNumber": "123456778"
            },
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "森岳",
                "importer": "森岳",
                "acquisitionStandard": "TW",
                "certificationBody": "中華",
                "additiveLicenseNumber": "123456778"
            }
        ],
        "transitionTotalArea": 0,
        "organicTotalArea": 0.0164,
        "usCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "249地號",
                "address": "高雄市美濃區廣林段249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "258地號",
                "address": "高雄市美濃區廣林段258地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "euCertificationFields": [
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                "address": "高雄市美濃區廣林段231地號",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "249地號",
                "area": "0.0062",
                "cropName": "地瓜、白蘿蔔",
                "harvestMonth": "10~3月",
                "estimatedOutput": "3000公斤"
            },
            {
                "fieldNo": "F01",
                "farmer": "王佳佳",
                "farmType": "organic",
                // "city": "kaohsiung",
                // "district": "美濃區",
                // "landLot": "廣林段",
                // "landSerialNo": "258地號",
                "address": "高雄市美濃區廣林段221地號",
                "area": "0.0102",
                "cropName": "地瓜葉、小白菜",
                "harvestMonth": "全年",
                "estimatedOutput": "600公斤"
            }

        ],
        "sourceTreatments": [
            {
                "cropName": "地瓜葉",
                "source": "seeds",
                "organicType": "organic",
                "seedTreatment": ["withoutMedication"]
            },
            {
                "cropName": "小白菜",
                "source": "seeding",
                "organicType": "nonOrganic",
                "seedTreatment": ["withMedication"],
                "medicationType": "抗細菌藥/金黃色葡萄球菌/依原體"
            }
        ]
    },
    {
        "no": "1008",
        "name": "簡單生活開發有限公司",
        "certificationStandards": [
            {
                "standard": "TW",
                "category": ["processing", "circulation"]
            }
        ],
        "certificateRegion": "domestic",
        "appNo": "202100028",
        "appType": "change",
        "formType": ["processing"],
        "createdOn": "2021-05-12T08:20:10.000Z",
        "taxIdNo": "28657415",
        "personInCharge": {
            "name": "翁家仁",
            "gender": "male",
            "idNo": "A123456789",
            "phone": "02-87735773",
            "mobilePhone": "0911234123"
        },
        "operatorType": "company",
        "identityType": "individual",
        "permanentAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "mailingAddress": {
            "country": "TW",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號"
        },
        "companyPhone": "02-7723-8001",
        "companyFax": "02-7723-8002",
        "contactPersons": [
            {
                "name": "Julia Shih",
                "mailingAddress": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "phone": "02-7723-8001沒人接請改打02-7723-8012",
                "mobilePhone": "0911230123",
                "email": "juliashih@gmail.com",
                "organicDedicated": true,
                "contactForToc": true,
                "remark": "聯絡人測試"
            }
        ],
        "certificationPlaces": [
            {
                "name": "桃園廠",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002882"
            },
            {
                "name": "台北廠",
                "address": {
                    "country": "TW",
                    "city": "taipei",
                    "district": "南港區",
                    "street": "三重路19-11號"
                },
                "hasRegistration": true,
                "registrationCertificateNo": "P65002834"
            },
            {
                "name": "新竹廠",
                "address": {
                    "country": "TW",
                    "city": "hsinchu",
                    "district": "東區新安路2號",
                    "street": "新安路2號"
                },
                "hasRegistration": false,
                "registrationCertificateNo": "P65002856"
            }
        ],
        "whetherHasOffsiteStorage": "yes",
        "offSiteStorages": [
            {
                "offsiteName": "桃園廠",
                "storeItems": "寶特瓶, 馬克杯",
                "useChemicalPreventionMaterial": "yes",
                "address": {
                    "country": "TW",
                    "city": "taoyuan",
                    "district": "中山區",
                    "street": "中山路19-11號"
                }
            },
        ],
        "entrustedCompanies": [
            {
                "name": "苗栗縣南庄鄉農會",
                "address": "桃園市中山區中山路19-11號",
                "phone": "02-7723-8001",
                "certificationBody": "國立中興大學 "
            }
        ],
        "certificationProducts": [
            {
                "name": "有機黑豆漿",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 200,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔1.jpg",
                                "lastModified": 0
                            },
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔2.jpg",
                                "lastModified": 0
                            }
                        ]
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔3.jpg",
                                "lastModified": 0
                            },
                        ]
                    }
                ],
                "compositions": [
                    {
                        "name": "水"
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 93.57,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "統盛國際股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "PRO-CRRT",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "友綠生活有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Ecocert Canada",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "四季有機國際有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                "additiveLicenseNumber": "123456799"
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "行健友善有機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機砂糖",
                        "proportion": 6.42,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機砂糖",
                                "originPlace": "巴拉圭",
                                "type": "organic",
                                "importer": "維多創新生機有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "Control Union Certifications B.V.",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "立圃產業有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT S.A",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機糖",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    },
                    {
                        "name": "碳酸氫鈉",
                        "proportion": 0.01,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "碳酸氫鈉",
                                "originPlace": "美國",
                                "type": "organic",
                                "manufacturer": "TATA CHEMICALS",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            }
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水"
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 93.57,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "統盛國際股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "PRO-CRRT",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "友綠生活有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Ecocert Canada",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "四季有機國際有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "INTERATIONAL CERTIFICATION SERVICES,INC",
                                        "additiveLicenseNumber": "123456799"
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "行健友善有機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機砂糖",
                                "proportion": 6.42,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機砂糖",
                                        "originPlace": "巴拉圭",
                                        "type": "organic",
                                        "importer": "維多創新生機有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "Control Union Certifications B.V.",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "立圃產業有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT S.A",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機糖",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "台灣糖業股份有限公司虎尾糖廠",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            },
                            {
                                "name": "碳酸氫鈉",
                                "proportion": 0.01,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "碳酸氫鈉",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "manufacturer": "TATA CHEMICALS",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    }
                                ]
                            }
                        ],
                    },
                ]
            },
            {
                "name": "有機豆瓣醬",
                "certificationPlace": ["桃園廠"],
                "certificateProductStandards": [
                    {
                        "certificationStandard": "TW",
                        "certificationType": ["processing"],
                    }
                ],
                "specs": [
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔1.jpg",
                                "lastModified": 0
                            },
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔2.jpg",
                                "lastModified": 0
                            }
                        ]
                    },
                    {
                        "type": "retail",
                        "weight": 500,
                        "weightUnit": "g",
                        "packingUnit": "罐",
                        "labelFiles": [
                            {
                                "type": "",
                                "size": 0,
                                "bytes": "",
                                "name": "標示圖檔3.jpg",
                                "lastModified": 0
                            },
                        ]
                    }
                ],
                "compositions": [
                    {
                        "name": "水",
                        "compositionLevel": "water"
                    },
                    {
                        "name": "有機蔗糖",
                        "proportion": 30,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "巴西",
                                "type": "organic",
                                "importer": "統一生機開發股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT SA",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機蔗糖(砂糖)",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "簡單生活開發公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ACO CERTIFICATION LTD",
                                "additiveLicenseNumber": "123456799"
                            }
                        ]
                    },
                    {
                        "name": "有機辣椒",
                        "proportion": 25,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "邱松榮",
                                "acquisitionStandard": "TW",
                                "certificationBody": "台灣省有機農業生產協會",
                                "additiveLicenseNumber": "123456778"
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吉品養生",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機辣椒",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "有機黃豆",
                        "proportion": 20,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機黃豆",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "吳俊佑(豐耕有機農場)",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                            },
                            {
                                "name": "有機黃豆",
                                "originPlace": "加拿大",
                                "type": "organic",
                                "importer": "綠昇貿易行銷有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ECOCERT CANADA",
                            }
                        ]
                    },
                    {
                        "name": "有機小麥",
                        "proportion": 10,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機小麥",
                                "originPlace": "美國",
                                "type": "organic",
                                "importer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "ICS",
                            },
                            {
                                "name": "有機小麥",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "十甲有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "MOA",
                            }
                        ]
                    },
                    {
                        "name": "海鹽",
                        "compositionLevel": "salt",
                        "rawMaterials": [
                            {
                                "name": "海鹽",
                                "originPlace": "澳洲",
                                "type": "organic",
                                "importer": "尚達鹽業",
                                "acquisitionStandard": "TW",
                            }
                        ]
                    },
                    {
                        "name": "有機香菇",
                        "proportion": 8,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機香菇",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "錦山有機農場",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    },
                    {
                        "name": "有機醬油",
                        "proportion": 5,
                        "compositionLevel": "organic",
                        "rawMaterials": [
                            {
                                "name": "有機醬油",
                                "originPlace": "台灣",
                                "type": "organic",
                                "manufacturer": "喜樂之泉股份有限公司",
                                "acquisitionStandard": "TW",
                                "certificationBody": "慈心有機驗證股份有限公司",
                                "additiveLicenseNumber": "123456778",
                                "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                            },
                        ]
                    },
                    {
                        "name": "乾海帶",
                        "proportion": 1.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "乾海帶",
                                "originPlace": "韓國",
                                "type": "organic",
                                "importer": "新藻實業有限公司",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]

                    },
                    {
                        "name": "種麴",
                        "proportion": 0.5,
                        "compositionLevel": "nonOrganic",
                        "rawMaterials": [
                            {
                                "name": "種麴",
                                "originPlace": "日本",
                                "type": "organic",
                                "importer": "萬通(世群貿易)",
                                "acquisitionStandard": "TW",
                                "additiveLicenseNumber": "123456778"
                            },
                        ]
                    }
                ],
                "rawMaterials": [
                    {
                        "certificateStandard":"TW",
                        "compositions": [
                            {
                                "name": "水",
                                "compositionLevel": "water"
                            },
                            {
                                "name": "有機蔗糖",
                                "proportion": 30,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "巴西",
                                        "type": "organic",
                                        "importer": "統一生機開發股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT SA",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機蔗糖(砂糖)",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "簡單生活開發公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ACO CERTIFICATION LTD",
                                        "additiveLicenseNumber": "123456799"
                                    }
                                ]
                            },
                            {
                                "name": "有機辣椒",
                                "proportion": 25,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "邱松榮",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "台灣省有機農業生產協會",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吉品養生",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機辣椒",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "有機黃豆",
                                "proportion": 20,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "吳俊佑(豐耕有機農場)",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                    },
                                    {
                                        "name": "有機黃豆",
                                        "originPlace": "加拿大",
                                        "type": "organic",
                                        "importer": "綠昇貿易行銷有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ECOCERT CANADA",
                                    }
                                ]
                            },
                            {
                                "name": "有機小麥",
                                "proportion": 10,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "美國",
                                        "type": "organic",
                                        "importer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "ICS",
                                    },
                                    {
                                        "name": "有機小麥",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "十甲有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "MOA",
                                    }
                                ]
                            },
                            {
                                "name": "海鹽",
                                "compositionLevel": "salt",
                                "rawMaterials": [
                                    {
                                        "name": "海鹽",
                                        "originPlace": "澳洲",
                                        "type": "organic",
                                        "importer": "尚達鹽業",
                                        "acquisitionStandard": "TW",
                                    }
                                ]
                            },
                            {
                                "name": "有機香菇",
                                "proportion": 8,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機香菇",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "錦山有機農場",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            },
                            {
                                "name": "有機醬油",
                                "proportion": 5,
                                "compositionLevel": "organic",
                                "rawMaterials": [
                                    {
                                        "name": "有機醬油",
                                        "originPlace": "台灣",
                                        "type": "organic",
                                        "manufacturer": "喜樂之泉股份有限公司",
                                        "acquisitionStandard": "TW",
                                        "certificationBody": "慈心有機驗證股份有限公司",
                                        "additiveLicenseNumber": "123456778",
                                        "composition": "水、有機黃豆、有機小麥、有機蔗糖、海鹽"
                                    },
                                ]
                            },
                            {
                                "name": "乾海帶",
                                "proportion": 1.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "乾海帶",
                                        "originPlace": "韓國",
                                        "type": "organic",
                                        "importer": "新藻實業有限公司",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]

                            },
                            {
                                "name": "種麴",
                                "proportion": 0.5,
                                "compositionLevel": "nonOrganic",
                                "rawMaterials": [
                                    {
                                        "name": "種麴",
                                        "originPlace": "日本",
                                        "type": "organic",
                                        "importer": "萬通(世群貿易)",
                                        "acquisitionStandard": "TW",
                                        "additiveLicenseNumber": "123456778"
                                    },
                                ]
                            }
                        ],
                    },
                ]
            }
        ],
        "rawMaterials": [
            {
                "name": "有機小麥",
                "originPlace": "美國",
                "type": "organic",
                "importer": "喜樂之泉股份有限公司",
                "acquisitionStandard": "TW",
                "certificationBody": "ICS",
                "affectedProducts": [
                    {
                        "name": "有機豆瓣醬",
                        "materials": ["有機香菇", "有機砂糖", "有機黃豆"]
                    },
                    {
                        "name": "有機醬油",
                        "materials": ["有機醬油", "有機小麥"]
                    }
                ]
            },
            {
                "name": "有機香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "錦山有機農場",
                "acquisitionStandard": "TW",
                "certificationBody": "慈心有機驗證股份有限公司",
                "additiveLicenseNumber": "123456778",
                "affectedProducts": [
                    {
                        "name": "有機豆瓣醬",
                        "materials": ["有機香菇", "有機砂糖", "有機黃豆"]
                    },
                    {
                        "name": "有機辣香菇",
                        "materials": ["有機香菇"]
                    }
                ]
            },
        ],
        "nonOrganicRawMaterials": [
            {
                "name": "小麥",
                "originPlace": "美國",
                "type": "organic",
                "importer": "喜樂之泉股份有限公司",
                "acquisitionStandard": "TW",
                "certificationBody": "ICS",
                "affectedProducts": [
                    {
                        "name": "豆瓣醬",
                        "materials": ["香菇", "砂糖", "黃豆"]
                    },
                    {
                        "name": "醬油",
                        "materials": ["醬油", "小麥"]
                    }
                ]
            },
            {
                "name": "香菇",
                "originPlace": "台灣",
                "type": "organic",
                "manufacturer": "錦山無機農場",
                "acquisitionStandard": "TW",
                "certificationBody": "慈心有機驗證股份有限公司",
                "additiveLicenseNumber": "123456778",
                "affectedProducts": [
                    {
                        "name": "豆瓣醬",
                        "materials": ["香菇", "砂糖", "黃豆"]
                    },
                    {
                        "name": "辣香菇",
                        "materials": ["香菇"]
                    }
                ]
            },
        ],
        "terminatedProducts": [
            {
                "product": "有機黑豆漿",
                "standard": "TW"
            },
            {
                "product": "有機香菇",
                "standard": "US"
            }
        ],
        "restoreQualification": [
            {
                "standard": "TW",
            },
            {
                "standard": "US",
            }
        ],
        "restoreProduct": [
            {
                "product": "有機黑豆漿"
            },
            {
                "product": "有機香菇"
            }
        ]
    },
]

export default processingApplicationDrafts;